import Button from '../Button'
import Image from 'next/image'

import gsap from 'gsap'
import SmallGirlImage from '../../../public/images/girl-small.png'
import SmallBoyImage from '../../../public/images/boy-small.png'
import CuteGirl from '../../../public/images/cute_girl.png'
import CuteBoy from '../../../public/images/cute_boy.png'
import React from 'react'
import {useRouter} from 'next/router'
import { useTranslation } from 'next-i18next'
import useUserPreferences from '@/hooks/useUserPreferences'

interface Props {
  title: string
  description: string
  subtitle: string
}

export default function PersonalizationSection({
  title,
  description,
  subtitle,
}: Props) {
  const preferences = useUserPreferences();
  const countryCode = preferences?.countryCode;
  const {locale} = useRouter();
  const {t} = useTranslation('common');
  const [nameError, setNameError] = React.useState('')
  const [genderError, setGenderError] = React.useState('')
  const [name, setName] = React.useState('')
  const [gender, setGender] = React.useState<'Male' | 'Female' | undefined>(
    'Male',
  )
  const router = useRouter()
  const SubmitForm = (type: '1' | '2') => {
    if (name === '') {
      setNameError(`${t('setNameError')}`)
      return
    } else {
      setNameError('')
    }
    if (gender === undefined) {
      setGenderError(`${t('setGenderError')}`)
      return
    } else {
      setGenderError('')
    }
    router.push(
      '/products?options=' +
        gender +
        '&name=' +
        name +
        '&gender=' +
        gender +
        '&product_type=' +
        type + 
        '&country=' + 
        preferences?.countryCode +
        '&currency=' +
        preferences?.currencyCode
    )
  }

  const genderSelected = (gender: 'Male' | 'Female') => {
    if (gender === 'Male' && locale === 'ar') {
      gsap.to('.cute-girl', {
        duration: 0.5,
        scale: 0.39,
        translateX: '5%',
        translateY: '-34%',
        zIndex: 5,
      })
      gsap.to('.cute-boy', {
        delay: 0.1,
        duration: 0.5,
        scale: 1.2,
        translateX: '0%',
        translateY: '-0%',
        zIndex: 0,
      })
    } else if(gender === 'Female' && locale === 'ar') {
      gsap.to('.cute-boy', {
        duration: 0.5,
        scale: 0.39,
        translateX: '-90%',
        translateY: '-34%',
        zIndex: 5,
      })
      gsap.to('.cute-girl', {
        delay: 0.1,
        duration: 0.5,
        scale: 1.2,
        translateX: '95%',
        translateY: '-0%',
        zIndex: 0,
      })
    } else if(gender === 'Male' && locale !== 'ar'){
      gsap.to('.cute-girl-global', {
        duration: 0.5,
        scale: 0.39,
        translateX: '-30%',
        translateY: '-35%',
        zIndex: 5,
      })
      gsap.to('.cute-boy', {
        delay: 0.1,
        duration: 0.5,
        scale: 1.2,
        translateX: '0%',
        translateY: '-0%',
        zIndex: 0,
      })
    }else if(gender === 'Female' && locale !== 'ar'){
      gsap.to('.cute-boy', {
        duration: 0.5,
        scale: 0.39,
        translateX: '90%',
        translateY: '-34%',
        zIndex: 5,
      })
      gsap.to('.cute-girl-global', {
        delay: 0.1,
        duration: 0.5,
        scale: 1.2,
        translateX: '-95%',
        translateY: '-0%',
        zIndex: 0,
      })
    }
  }
  return (
    <div
      id="personalization"
      className="overflow-hidden lg:overflow-hidden mx-auto relative "
      dir={`${locale === 'ar' ? 'rtl': 'ltr'}`}
      >
      <div className="container-fluid grid personalization-grid h-full z-10 lg:pb-32 xl:pb-16 2xl:pb-14" dir={`${locale === 'ar' ? 'rtl': 'ltr'}`}>
        <div className={`personalization-text text-center ${locale === 'ar' ? 'md:text-right ' : 'md:text-left'}`} dir={`${locale === 'ar' ? 'rtl': 'ltr'}`}>
          <h2 className="text-primary text-base md:text-[2.5rem] 2xl:text-[3rem] font-semibold leading-[1.3]">
            {title}
          </h2>
          <p className="font-medium mt-4 text-primary text-xs 2xl:text-base">
            {description}
          </p>
        </div>
        <div className="choose-gender-form mt-16  md:mt-8 lg:mt-16  md:flex md:flex-row-reverse relative">
          <div className={`gender-images md:w-[55%] relative mb-8 md:mb-0 md:z-0 z-[18] ${locale === 'ar' ? '' : 'left-20 top-10 md:mb-4'}`}>
            <div className={`${locale === 'ar' ? 'rings' : 'rings-global'} absolute`}>
              <svg
                viewBox="0 0 123 107"
                fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <circle cx="85.7334" cy="69.7231" r="37.2607" fill="#00214D" />
                <circle
                  cx="48.6176"
                  cy="48.431"
                  r="34.6712"
                  stroke="#FF5470"
                  strokeWidth="26.4709"
                />
              </svg>
            </div>
            <div className="cute-boy cute-main">
              <div className={`${locale === 'ar' ? 'cute-boy-bg cute-bg' : 'cute-boy-bg cute-bg-global'}`}></div>
              <Image
                src={CuteBoy}
                className="cute-boy-img cute-img"
                priority={true}
                alt="boy"
              />
            </div>

            <div className={`${locale === 'ar' ? 'cute-girl cute-main': 'cute-girl-global cute-main'}`}>
              <div className={`cute-girl-bg cute-bg-global`}></div>
              <Image
                src={CuteGirl}
                className="cute-girl-img cute-img"
                priority={true}
                alt="girl"
              />
            </div>
          </div>

            <div className={`md:absolute md:w-1/2 ${locale === 'ar' ? 'right-0 bottom-16 ': 'left-0 bottom-6'} md:bottom-auto relative z-10`}>
            <div className={`top-yellow-ellipse absolute z-[9] -top-[10%] ${locale === 'ar'? 'left-[6%]' : 'right-[6%]'}`}>
              <svg
                width="158"
                height="158"
                viewBox="0 0 158 158"
                fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <circle cx="79" cy="79" r="79" fill="#FBDD37" />
              </svg>
            </div>
            <div className="choose-gender bg-white pt-8 pb-4 px-4 rounded-2xl relative z-10">
              <div className={`ribbon ${locale === 'ar' ? 'absolute': 'hidden'} -top-2 right-0`}>
                <svg
                  width="50"
                  height="35"
                  viewBox="0 0 50 35"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M35.3477 29.4763C38.1963 29.8884 41.0936 29.8234 43.9208 29.2841C44.7445 29.1344 45.569 28.9412 46.3934 28.7481C46.988 28.6054 47.6143 28.6878 48.1517 28.9792C48.6892 29.2707 49.0998 29.7507 49.3046 30.3268C49.4912 30.9378 49.4345 31.5973 49.1463 32.1674C48.858 32.7375 48.3605 33.1742 47.7579 33.3861C45.6954 34.0252 43.5609 34.4027 41.4043 34.5101C37.0426 34.7866 32.6656 34.3188 28.4608 33.1268C24.494 32.0198 20.7051 30.3537 17.2079 28.1787C12.6944 25.4604 8.76357 21.8755 5.64223 17.6307C2.94136 13.9652 1.05984 9.762 0.125165 5.3059C-0.0233815 4.60011 -0.117509 3.88394 -0.156397 3.16374C-0.152404 2.56651 0.0656423 1.99052 0.458153 1.54038C0.850665 1.09023 1.39161 0.795763 1.98274 0.710483C2.5944 0.636875 3.21087 0.802412 3.70336 1.17255C4.19585 1.54269 4.5263 2.0888 4.62568 2.6968C5.38364 7.88173 7.61491 12.7399 11.0541 16.6934C11.1793 16.8887 11.344 17.0556 11.5376 17.1834C11.7312 17.3112 11.9495 17.397 12.1783 17.4353C11.6498 16.7478 11.2764 15.954 11.0836 15.1086C9.99758 12.6755 9.53945 10.0087 9.75113 7.35269C9.82918 5.883 10.3029 4.46175 11.1223 3.2392C11.9418 2.01665 13.0763 1.03824 14.4061 0.407499C15.3925 -0.0681625 16.4666 -0.334427 17.561 -0.374603C18.6553 -0.414779 19.7462 -0.227996 20.7648 0.174058C24.6777 1.59767 26.7503 4.58976 27.8294 8.45369C28.4917 11.1605 28.618 13.9707 28.2011 16.7259C28.1811 16.8689 28.1263 17.0155 28.2713 17.1572C28.9286 16.8437 29.5819 16.5171 30.2605 16.2257C32.3448 15.2285 34.7316 15.0662 36.9317 15.7722C38.3903 16.1892 39.6635 17.0902 40.5419 18.3269C41.4204 19.5636 41.8518 21.0625 41.7652 22.577C41.5824 25.1665 40.0338 26.9315 37.873 28.2116C37.2788 28.5703 36.6435 28.8559 35.9809 29.0625C35.8466 29.0812 35.7184 29.1306 35.6063 29.2069C35.4941 29.2831 35.401 29.3842 35.3342 29.5021L35.1449 29.4031L35.1179 29.4547L35.3477 29.4763ZM19.7461 4.96753C19.2937 4.68183 18.7786 4.51037 18.2453 4.46791C17.7119 4.42545 17.1762 4.51325 16.6843 4.72378C16.0372 5.01662 15.4908 5.49374 15.1134 6.09546C14.736 6.69717 14.5445 7.39676 14.5626 8.10679C14.4827 9.72212 14.7612 11.3351 15.3782 12.8301C16.7589 16.2889 18.7224 19.4854 21.1832 22.2807C21.4889 22.6599 21.6703 22.711 21.8582 22.1847C23.344 17.9645 24.3529 13.6922 23.0676 9.23804C22.8594 8.32685 22.4542 7.47231 21.8804 6.73452C21.3065 5.99673 20.578 5.3936 19.7461 4.96753ZM26.6252 25.3268C28.8204 25.5452 31.0365 25.4061 33.1871 24.9147C34.338 24.7131 35.4064 24.1841 36.2644 23.391C36.5228 23.182 36.715 22.9025 36.8178 22.5865C36.9206 22.2704 36.9296 21.9314 36.8436 21.6103C36.7577 21.2893 36.5805 21.0001 36.3335 20.7777C36.0866 20.5553 35.7804 20.4093 35.4522 20.3573C34.5917 20.109 33.6768 20.1222 32.8238 20.3952C30.198 21.2237 28.3655 23.0702 26.6166 25.3223L26.6252 25.3268Z"
                    fill="#0CDFBF"
                  />
                </svg>
              </div>
              <div className={`${locale === 'ar' ? 'hidden': 'absolute'} ribbon left-0 top-0`}>
                <svg 
                  xmlns="http://www.w3.org/2000/svg" 
                  width="50" 
                  height="35" 
                  viewBox="0 0 74 53" 
                  fill="none"
                >
                  <path d="M21.212 44.5658C16.9885 45.1768 12.6927 45.0804 8.50078 44.2808C7.27952 44.0588 6.05707 43.7725 4.8346 43.4862C3.9531 43.2746 3.0245 43.3967 2.2276 43.8288C1.43071 44.261 0.82186 44.9727 0.51832 45.8269C0.241573 46.7328 0.325661 47.7106 0.753026 48.5559C1.1804 49.4012 1.91801 50.0487 2.81161 50.3629C5.86961 51.3104 9.03445 51.8702 12.2319 52.0293C18.6991 52.4393 25.1888 51.7458 31.4233 49.9784C37.3047 48.337 42.9226 45.8667 48.1078 42.642C54.8 38.6115 60.6281 33.2962 65.2561 27.0025C69.2607 21.5676 72.0504 15.3356 73.4362 8.72856C73.6565 7.68209 73.796 6.62024 73.8537 5.55239C73.8478 4.66688 73.5245 3.81288 72.9425 3.14545C72.3605 2.47801 71.5585 2.04141 70.682 1.91497C69.7751 1.80583 68.8611 2.05127 68.1309 2.60007C67.4007 3.14887 66.9107 3.95859 66.7634 4.86007C65.6395 12.5477 62.3312 19.7509 57.232 25.6127C57.0464 25.9023 56.8022 26.1498 56.5151 26.3393C56.228 26.5288 55.9044 26.656 55.5652 26.7128C56.3487 25.6934 56.9024 24.5165 57.1882 23.263C58.7985 19.6554 59.4778 15.7014 59.1639 11.7633C59.0482 9.58422 58.3457 7.47694 57.1308 5.66428C55.9159 3.85161 54.2336 2.40094 52.262 1.46574C50.7995 0.760476 49.2069 0.365689 47.5843 0.30612C45.9617 0.246552 44.3443 0.523493 42.834 1.11962C37.0323 3.2304 33.9593 7.66674 32.3593 13.3958C31.3774 17.4091 31.1902 21.5758 31.8082 25.661C31.8379 25.8729 31.9192 26.0904 31.7042 26.3004C30.7295 25.8356 29.761 25.3513 28.7548 24.9193C25.6644 23.4407 22.1255 23.2001 18.8634 24.2469C16.7009 24.8651 14.8131 26.201 13.5106 28.0347C12.2081 29.8684 11.5684 32.0907 11.6968 34.3362C11.9679 38.1758 14.264 40.7927 17.4678 42.6907C18.3488 43.2225 19.2908 43.646 20.2733 43.9522C20.4724 43.98 20.6624 44.0533 20.8287 44.1663C20.9949 44.2794 21.133 44.4292 21.2321 44.6041L21.5127 44.4572L21.5527 44.5338L21.212 44.5658ZM44.3444 8.22686C45.0152 7.80325 45.7789 7.54904 46.5697 7.48608C47.3606 7.42312 48.1548 7.5533 48.8842 7.86545C49.8436 8.29965 50.6538 9.00707 51.2133 9.89923C51.7728 10.7914 52.0569 11.8287 52.03 12.8814C52.1484 15.2765 51.7355 17.668 50.8207 19.8847C48.7734 25.0129 45.8623 29.7523 42.2137 33.897C41.7604 34.4592 41.4914 34.535 41.2128 33.7546C39.0099 27.4974 37.514 21.1628 39.4197 14.5587C39.7284 13.2077 40.3292 11.9407 41.18 10.8468C42.0308 9.75284 43.1109 8.8586 44.3444 8.22686ZM34.1448 38.4134C30.89 38.7373 27.6043 38.5309 24.4156 37.8024C22.7092 37.5035 21.125 36.7192 19.8528 35.5432C19.4697 35.2333 19.1847 34.8189 19.0323 34.3504C18.8799 33.8818 18.8666 33.379 18.994 32.903C19.1215 32.427 19.3842 31.9982 19.7503 31.6685C20.1165 31.3387 20.5704 31.1222 21.0571 31.0451C22.333 30.677 23.6895 30.6965 24.9543 31.1014C28.8475 32.3297 31.5645 35.0676 34.1575 38.4067L34.1448 38.4134Z" fill="#0CDFBF"/>
                </svg>
              </div>
              <p className="text-primary text-center text-sm md:text-base lg:text-base xl:text-xl">
                {subtitle}
              </p>
              <form className="name-form mt-5  w-full">
                <div className="options flex items-center justify-center">
                  <div className="option w-full">
                    <button
                      onClick={() => {
                        setGender('Male')
                        genderSelected('Male')
                        if (gender) setName('')
                      }}
                      type="button"
                      className={`w-full border-2 rounded-md transition duration-300 px-6 flex justify-center items-center py-2 ${
                        gender === 'Male'
                          ? 'bg-success text-white border-success'
                          : 'text-blue'
                      }`}>
                      <p>{t('maleText')}</p>
                      <span className={`${locale === 'ar' ? 'mr-2': 'ml-2'}`}>
                        <Image
                          src={SmallBoyImage}
                          className="w-6 h-6"
                          alt="small-boy"
                        />
                      </span>
                    </button>
                  </div>

                  <div className={`option text-center w-full ${locale === 'ar' ? 'mr-4': 'ml-4'}`}>
                    <button
                      onClick={() => {
                        setGender('Female')
                        genderSelected('Female')
                        if (gender) setName('')
                      }}
                      type="button"
                      className={`w-full border-2 rounded-md transition  duration-300  px-6 flex justify-center items-center py-2
                  ${
                    gender === 'Female'
                      ? 'bg-success text-white border-success'
                      : 'text-pink'
                  }
                  `}>
                      <p>{t('femaleText')}</p>
                      <span className={`${locale === 'ar' ? 'mr-2': 'ml-2'}`}>
                        <Image
                          src={SmallGirlImage}
                          className="w-6 h-6"
                          alt="small-girl"
                        />
                      </span>
                    </button>
                  </div>
                </div>

                <input
                  type="text"
                  placeholder={`${t('childNamePlaceholder')}`}
                  onChange={e => {
                    setName(e.target.value)
                  }}
                  value={name}
                  className="rounded-md w-full py-[0.85rem] placeholder-gray-400 text-sm border-gray-300 border-1 mt-4"
                />
                <p className="text-red text-sm font-semibold mt-2">
                  {nameError}
                </p>
                <p className="text-red text-sm font-semibold mt-2">
                  {genderError}
                </p>
                <div className="flex flex-col items-center justify-center text-center">
                  <Button
                    type="button"
                    onClick={e => {
                      SubmitForm('1')
                    }}
                    bg="primary"
                    classes={['w-full', 'mt-2', 'font-semibold', 'py-4', 'text-sm', 'md:text-base', 'lg:text-base']}>
                    <>{t('exploreStories')}</>
                  </Button>

                  {countryCode === 'IL' && (
                    <button
                      type="button"
                      onClick={e => {
                        SubmitForm('2')
                      }}
                      className="w-full h-[56px] flex items-center justify-center text-primary border border-primary mt-2 lg:mt-4 font-semibold py-4 rounded-md text-sm md:text-base lg:text-base">
                      <>{t('exploreNotebooks')}</>
                    </button>
                  )}
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
